import myAjax from "./http";
import Qs from "qs";
import store from "../../store/index";
var myaxios = {
	
	// 原药材
	originBuyer: (params) => myAjax.post(`originBuyer/login`, params),//原药材账号注册
    originBuyerLogin: (params) => myAjax.post(`originBuyer/logon`, params),//原药材密码登录 
	codelogon: (params) => myAjax.post(`originBuyer/codelogon`, params),//原药材验证码登录
	originBuyerCode: (params) => myAjax.post(`originBuyer/sendsms`, params),//原药材获取验证码
	putOriginPassWord: (params) => myAjax.put(`originBuyer/backpwd`, params),//找回密码
	
	originProductList: (params) => myAjax.post(`originProduct/originProductList`,params),//原药采购列表页
	insMessage: (params) => myAjax.post(`messageBoard/insMessage`,params),//新增留言
	getMessage: (params) => myAjax.post(`/messageBoard/getMessage`,params),//查询留言
	delMessage: (id) => myAjax.delete(`messageBoard/delMessage/${id}`),//删除留言
	getSupplyOrDemand: (params) => myAjax.post(`productSupplyAndDemand/getSupplyOrDemand`,params),//供应
	getMySupplyOrDemand: (params) => myAjax.post(`productSupplyAndDemand/getMySupplyOrDemand`,params),//个人供应
	insDemand: (params) => myAjax.post(`productSupplyAndDemand/insDemand`,params),//需求新增
	updateDemand: (params) => myAjax.put(`productSupplyAndDemand/updateDemand`,params),//需求更新
	delSupplyOrDemandById: (id) => myAjax.delete(`productSupplyAndDemand/delSupplyOrDemandById/${id}`),//删除供应、需求
	insSupply: (params) => myAjax.post(`productSupplyAndDemand/insSupply`,params),//新增供应
	updateSupply: (params) => myAjax.put(`productSupplyAndDemand/updateSupply`,params),//更新供应
	getOriginInfo: (params) => myAjax.post(`originInfo/getOriginInfo`,params),//原药资讯
	//查留言
	getShopMessage: (params) => myAjax.post(`messageBoard/getShopMessage`,params),
	
	getOriginProductByMsg: (params) => myAjax.post(`originProduct/getOriginProductByMsg`,params),//我的留言商品
	
	// 查询店铺详情
	getShopById: (params) => myAjax.get(`originProduct/getShopById/${params}`),
	
	// 已读
	updateRead: (params) => myAjax.post(`messageBoard/updateRead/${params}`),
	
	
	// 获取资质
	getSelectByBuyerId: (params) => myAjax.get(`originBuyerInfo/selectByBuyerId/${store.state.buyerId}`),
	// 更新资质
	updateBuyerInfo: (params) => myAjax.post(`originBuyerInfo/updateBuyerInfo`,params),
	// app发布商品
	addOriginProduct: (params) => myAjax.post(`originProduct/addOriginProduct`,params),
	// 修改发布的商品
	updateOriginById: (params) => myAjax.put(`originProduct/updateOriginById`,params),
	// 商品删除
	delOriginByIds: (params) => myAjax.delete(`originProduct/delOriginByIds/${params}`),
	
	// 入库
	addOriginWarehouse: (params) => myAjax.post(`originWarehouse/add`,params),
	
	// 商品详情
	getOriginProductById: (params) => myAjax.get(`originProduct/getOriginProductById/${params}`),
	
	// 入库列表
	getOriginWarehouseList: (params) => myAjax.post(`originWarehouse/getOriginWarehouseList`,params),
	
	// 入库详情
	getOriginWarehouseById: (params) => myAjax.get(`originWarehouse/getOriginWarehouseById/${params}`),
	
	insUserFeedback: (params) => myAjax.post(`userFeedback/insUserFeedback`, params),//反馈投诉
	getListByUserId: (params) => myAjax.get(`userFeedback/getListByUserId/${store.state.buyerId}?${params}`),//反馈投诉列表
	// getListByUserId: (params) => myAjax.post(`userFeedback/getListByUserId/${store.state.buyerId}`,params),//反馈投诉列表
	addReservation: (params) => myAjax.post(`reservation/addReservation`, params),//到货提醒
	getBuyerType: (params) => myAjax.get(`buyer/getBuyerType/${store.state.buyerId}`),//新老用户判断
	convertBase64ToImage: (params) => myAjax.postJson(`order/convertBase64ToImage`, params),//下载支付码
    getNoticeList: (params) => myAjax.get(`announcement/user/list?${params}`),//消息通知
    getNoticeDetail: (params) => myAjax.get(`announcement/user/${params}`),//消息通知详情
    changeSales: (params) => myAjax.post(`sales/changeSales`, params),//更换业务员
    queryMySales: (params) => myAjax.get(`sales/queryMySales/${params}`),//查询我的业务员
    postdetailBindCard: (params) => myAjax.get(`zjRegister/getBindCardInfo/${params}`),//查询我的业务员
    getOngoingActivity: (params) => myAjax.get(`home/getOngoingActivity`),//超级秒杀倒计时
	getClickNum: (params) => myAjax.post(`userClick/addClickLog`,params),//模块点击量
	getSendCode: (params) => myAjax.post(`buyer/sendPublicSms/${params}`),//注销发送验证码
	getPurchasedList: (params) => myAjax.get(`home/getPurchasedList?${params}`),//常购清单
    getCtiy: () => myAjax.get(`UrbanDictionary/tree`),//城市
    // getQueryList: () => myAjax.get(`burstScreen/queryList?state=1`),//炸屏
    // getQueryList: (params) => myAjax.get(`burstScreen/queryList?${params}`),//炸屏
	getQueryList: (params) => myAjax.get(`burstScreen/queryListForApp?${params}`),//炸屏
    showCoupon: (params) => myAjax.get(`coupcon/showCoupon?${params}`),//是否展示领优惠券弹窗
    getAllShop: () => myAjax.get(`ShopCase/getAllShop`),//炸屏
    upData: (params) => myAjax.post(`upload/fileupload`, params),//上传图片  
    upData1: (params) => myAjax.post(`buyer/updateBuyerPhoto`, params),//修改客户头像
    upDatas: (params) => myAjax.post(`upload/uploadVoucher`, params),//上传图片  
    homeProduct: (params) => myAjax.post(`home/guess?${params}`, ""),//首页的猜你喜欢商品列表
    LBTcarousel: (params) => myAjax.get(`carousel/carousel?${params}`),//首页的轮播图
    homeColumn: (params) => myAjax.get(`home/homeclassify?${params}`),//首页的栏目
    getNoDrug: (params) => myAjax.post(`separate/getNoDrug`, params),//首页的栏目
    queryCarouseing: (params) => myAjax.post(`carouselsale/queryCarouseing`, params),//首页的活动专区下的轮播图
    newsList: (params) => myAjax.post(`news/newslist?${params}`),//首页的新闻公告
	getNewsInfo: (params) => myAjax.get(`news/getNewsInfo/${params}`),//首页的新闻公告
    topShopCase: (params) => myAjax.post(`carouselsale/queryShopProduct`, Qs.stringify(params)),//首页的优质商铺
    recommend: (params) => myAjax.post(`home/recommend`, Qs.stringify(params)),//首页的超级秒杀
    hotsell: (params) => myAjax.post(`home/hotsell`, Qs.stringify(params)),//首页的超级秒杀
    getFixedBanner: () => myAjax.get(`home/getFixedBanner`),//首页的超级秒杀
    getFixedProduct: (params) => myAjax.get(`home/getFixedProduct`),//超级秒杀
    // topShopCase: () => myAjax.post(`home/topShopCase`, ""),//首页的优质商铺
    goldLBT: (params) => myAjax.post(`home/topProduct?${params}`),//首页的黄金区域  每周特卖
    qualifications: (params) => myAjax.get(`buyer/info/${params}`),//首页查询资质信息 

    selectMaxPageview: () => myAjax.get(`product/selectMaxPageview`),//热门搜索
    productNameAssociate: (params) => myAjax.get(`product/productNameAssociate?${params}`),//搜索联想

    receiptMsg: (params) => myAjax.get(`webSocket/receiptMsg?${params}`),//搜索联想
	
	
	// 查询预购商品
	preProductList: (params) => myAjax.get(`preProduct/list?${params}`, ""),
	
	// 商品详情
	preProductDetail: (params) => myAjax.get(`preProduct/selectOne/${params}`, ""),
	
	// 添加商品到清单
	addPreOrder: (params) => myAjax.post(`preOrder/add`, params),
	
	// 查看清单列表
	preOrderList: (params) => myAjax.get(`preOrder/list?${params}`, ""),
	
	// 查看清单详情
	listDetail: (params) => myAjax.get(`preOrder/listDetail?${params}`, ""),
	
	// 删除清单产品
	updateOrderInfo: (params) => myAjax.post(`preOrder/updateOrderInfo`, params),
	
	// 锁定清单（提交清单）
	subPreOrder: (params) => myAjax.post(`preOrder/sub`, params),
	
	// 删除清单
	delPreOrder: (params) => myAjax.post(`preOrder/delete`, params),
	
	// 创建订单
	createPreOrder: (params) => myAjax.post(`preOrder/createOrder`, params),
	
	// 加购
	addToShopCar: (params) => myAjax.post(`preOrder/addToShopCar`, params),
	
	
	
	

    login: (params) => myAjax.post(`buyer/login`, params),//密码登录 
	
	delUser: (params) => myAjax.post(`buyer/delUser/${params}`),//注销
	
    postRegister: (params) => myAjax.post(`buyer/add`, params),//账户注册 
    signIng: (params) => myAjax.post(`sign/sign`, params),//签到
    querySignIng: () => myAjax.post(`sign/querySignIng`,),//签到
    selecSignScore: () => myAjax.get(`sign/selecSignScore`),//签到
    queryCurrentSign: () => myAjax.get(`sign/queryCurrentSign`),//签到
    //环信
    postIMtoken: () => myAjax.post(`Im/getAccessToken`),//环信注册获取token  Im/registerUser 聊天室功能暂时不用
    postIMregister: (params) => myAjax.post(`Im/registerUser`, params),//环信注册 
    //资质 
    getManagement: (params) => myAjax.get(`manager/list?${params}`),//经营范围 
    postAddQualifications: (params) => myAjax.post(`buyer/addUserQual`, params),//上传资质信息
    getDelQualifications: (params) => myAjax.get(`buyer/delUserQual?${params}`),//备份资质图片删除
    postQueryQualifications: (params) => myAjax.post(`buyer/queyrUserQual/${params}`),//查询资质信息图片
    postEditQualifications: (params) => myAjax.post(`buyer/info`, params),//资质信息修改 buyer/ImproveUserQual
    postImproveUserQual: (params) => myAjax.post(`buyer/ImproveUserQual`, Qs.stringify(params)),//资质完善 

    Myorder: (params) => myAjax.get(`order/count?${params}`),//全部订单数量
    collection: (params) => myAjax.get(`collect/coll/${params}`),//收藏
    deleteCollection: (params) => myAjax.delete(`collect/coll/${params}`),//移除收藏
    postCollection: (params) => myAjax.post(`collect/coll`, params),//添加收藏
    sendsms: (params) => myAjax.post(`buyer/sendsms?${params}`),//获取登录验证码  
    codelogin: (params) => myAjax.post(`buyer/codelogin`, params),//验证码登录  buyer/pwd
    modifyPassWord: (params) => myAjax.put(`buyer/pwd`, params),//修改密码
    putforgetPassWord: (params) => myAjax.put(`buyer/backpwd`, params),//忘记密码

    classifyNav: () => myAjax.post(`classify/list`),//一级分类  
    myCoupons: (params) => myAjax.get(`coupcon/usable?${params}`),//我的优惠券
    postActivity: (params) => myAjax.post(`activi/getActiByShopId`, Qs.stringify(params)),//活动
    getCoupon: (params) => myAjax.get(`coupcon/ablecoupon?${params}`),//优惠券列表  
    receiveCoupon: (params) => myAjax.post(`coupcon/pull`, params),//领取优惠券 
    getLiveCoupon: () => myAjax.get(`coupcon/getLiveCoupon`),//直播优惠券列表 
    postColumn: (params) => myAjax.post(`product/prolist?${params}`),//栏目专区中商品列表 
    postSearch: (params) => myAjax.post(`product/searcht?${params}`),//全部商品搜索
	
	getNewBuyerProduct: (params) => myAjax.get(`product/getNewBuyerProduct?${params}`),//一元秒杀
	
	getAllRoom: (params) => myAjax.post(`chat/getAllRoom`),//获取房间号
	







    selectProShop: () => myAjax.get(`ShopCase/selectProShop`),//全部商品搜索
    getPackage: (params) => myAjax.get(`activi/actpro/${params}`),//套餐包列表    
    postProductDetails: (params) => myAjax.post(`product/proinfo`, params),//商品详情  
    addPageview: (params) => myAjax.post(`product/addPageview/${params}`),//商品浏览量 
    postQueryPackProduct: (params) => myAjax.post(`product/queryPackProduct`, params),//套餐包中的商品   
    JoinShopcar: (params) => myAjax.post(`shopcar/shopcar`, params),//加入购物车  
    createOrder: (params) => myAjax.post(`order/createOrder`, params),//立即购买 
    shopcarList: (params) => myAjax.get(`shopcar/shopcount/${params}`),//加入购物车中的商品列表 
    getProductBook: (params) => myAjax.get(`product/probook/${params}`),//商品说明书 
    getCommentList: (params) => myAjax.post(`comment/getCommentList`, params),//商品---评论列表
    getMyOrder: (params) => myAjax.get(`order/myorder?${params}`),//我的订单 
    getOrderDetails: (params) => myAjax.get(`order/orderinfo/${params}`),//订单详情 
    putOrderRemove: (params) => myAjax.put(`order/cancel/${params}`),//取消订单  
    // postLogistics: (params) => myAjax.post(`order/getState/${params}`),//查看物流
    postLogistics: (params) => myAjax.post(`express/getState`, Qs.stringify(params)),//查看物流
    getExpressType: () => myAjax.post(`express/getExpressType`),//查看物流

    putReceiving: (params) => myAjax.put(`order/deliall/${params}`),//收货

    orderValidateCoupons: (params) => myAjax.get(`order/validateCoupons?${params}`),//验证优惠券


    postRefund: (params) => myAjax.post(`refundPay/buyerRefund`, params),//申请退款 refundPay/getBuyerRefund/   buyerRefund
    postBuyerRefund: (params) => myAjax.post(`refundPay/getBuyerRefund/${params}`),//退款信息
    postLogOrderNo: (params) => myAjax.post(`refundPay/setLogOrderNo/${params}`),//更新物流
    postcancelBuyerRefund: (params) => myAjax.post(`refundPay/cancelBuyerRefund/${params}`),//取消退款

    postEvaluate: (params) => myAjax.post(`comment/add`, params),//评价 
    getShoppingCart: (params) => myAjax.get(`shopcar/shopcarlist/${params}`),//购物车中的商品 
    getAccount: (params) => myAjax.get(`shopcar/account?${params}`),//算钱  
    verification: (params) => myAjax.get(`shopcar/verification/${params}`),//失效商品  
    putShoppingNum: (params) => myAjax.put(`shopcar/upnum`, params),//添加购物车单个商品数量 
    delShoppingCart: (params) => myAjax.delete(`shopcar/shopcars?${params}`),//删除购物车中的商品
    getAddress: (params) => myAjax.get(`buyer/Auditaddress/${params}`),//收货地址列表 
    postOrderAccount: (params) => myAjax.post(`order/order`, params),//提交订单     
    getSales: () => myAjax.get(`producrBind/querySales`),//业务员列表   
    getOrderAccount: (params) => myAjax.get(`order/initOrder/${params}`),//支付订单详情 
    postSaveInvoice: (params) => myAjax.post(`order/saveInvoice`, params),//存发票 
    getInvoice: (params) => myAjax.get(`buyer/invoice/${params}`),//取发票 
    postFreight: (params) => myAjax.post(`order/freight`, params),//运费 
	
	postPrice: (params) => myAjax.post(`order/getFreightInfo`, params),//查询最低包邮线
	
    saveProductSale: (params) => myAjax.get(`order/saveProductSale?${params}`),//运费 
    getPaymethod: () => myAjax.get(`paymethod/use`),//支付方式 
	
    getWXpay: (params) => myAjax.post(`order/pay`, params),//微信支付  中金支付
	
	
    arrearsSubmit: (params) => myAjax.post(`order/arrearsSubmit`, params),//微信支付  
    postQueryQuick: (params) => myAjax.post(`zjRegister/quertBuyeyState/${params}`),//快捷支付是否开过户  
    postFastPay: (params, data) => myAjax.post(`order/fastPay/${params}`, Qs.stringify(data)),//输入密码支付 
    getPayResult: (params) => myAjax.get(`order/payResult/${params}`),//查询是否支付成功 
    getOrderinfo: (params) => myAjax.get(`order/orderinfo/${params}`),//查看订单信息
	
	getWinCode: (params) => myAjax.get(`getWinCode/${params}`),//微信登录
	
	
	
	
	// ------------------桔禾付-------------------------
	getPayChannel: () => myAjax.get(`jhf/queryPayChannel/`),//支付方式
	getOrderPayStatus: (params) => myAjax.get(`jhf/getOrderPayStatus/${params}`),//查询是否支付成功
	getWXjhfPay: (params) => myAjax.post(`order/jhfPay`, params),//微信支付  桔禾付
	
	
	
	
	
	
	
	
	
	
	
    postPhotocopy: (params) => myAjax.post(`zjRegister/photocopyCollection`, Qs.stringify(params)),//采集影件  
    getBank: (params) => myAjax.get(`Zj/bank?${params}`),//银行
    getCtiyTree: () => myAjax.get(`Zj/cityTree`),//城市 
    getClassifyType: () => myAjax.get(`Zj/classifyType`),//分类类别 
    getIndustry: () => myAjax.get(`Zj/industry`),//行业代码 
    getGeneralIndustry: (params) => myAjax.get(`Zj/generalIndustry?${params}`),//通用行业代码 
    postBindCard: (params) => myAjax.post(`zjRegister/bindCardApplication/${store.state.buyerId}`, params),//申请绑卡
    postAddBindCard: (params) => myAjax.post(`zjRegister/bindCardConfirm/${store.state.buyerId}`, params),//确认绑卡  zjRegister/openUser/ 
    postOpenUser: (params) => myAjax.post(`zjRegister/openUser/${store.state.buyerId}`, Qs.stringify(params)),//确认开户

    postVideo: (params) => myAjax.post(`video/queryVideoList`, params),//视频列表 
    postChapter: (params) => myAjax.post(`video/queryVideoChapter`, params),//章节列表
    postVideoInfo: (params) => myAjax.post(`video/queryVideoInfo`, params),//课时列表  /
    getBrief: (params) => myAjax.get(`video/queryVideoListById/${params}`),//简介 video/getVideoComment/
    getComment: (params) => myAjax.get(`video/getVideoComment/${params}`),//评论 video/addVideoComment
    postAddComment: (params) => myAjax.post(`video/addVideoComment`, params),//添加评论

    postAddMsgNum: (params) => myAjax.post(`im/addMsgNum`, Qs.stringify(params)),//添加未读信息


    getAddress: () => myAjax.get(`buyer/address/${store.state.buyerId}`),//收货地址列表 
    putAddress: (params) => myAjax.put(`buyer/address`, params),//修改收货地址
    postAddress: (params) => myAjax.post(`buyer/address`, params),//新增收货地址
    delAddress: (params) => myAjax.delete(`buyer/delete/${params}`),//删除收货地址 

    getAddSales: (params) => myAjax.get(`producrBind/add?${params}`),//增加业务员 
    getSales: () => myAjax.get(`producrBind/querySales`),//业务员列表

    postNewProduct: (params) => myAjax.post(`NewProduct/query`, Qs.stringify(params)),//新品登记列表 
    postAddNewProduct: (params) => myAjax.post(`NewProduct/add`, params),//新品登记增加 
    postUpdateNewProduct: (params) => myAjax.post(`NewProduct/update`, params),//新品登记修改
    getDelNewProduct: (params) => myAjax.get(`NewProduct/delete/${params}`),//新品登记删除


    postAllShopCase: (params) => myAjax.post(`ShopCase/allShopCase?${params}`),//店铺列表
    getCarousel: (params) => myAjax.get(`carousel/carousel?${params}`),//店铺轮播列表 
    getAllProduct: (params) => myAjax.get(`product/AllProduct?${params}`),//店铺商品列表  
    getShopAptitudes: (params) => myAjax.get(`ShopCase/getShopAptitudes/${params}`),//店铺资质信息  
    getShopInfo: (params) => myAjax.get(`ShopCase/getShopInfo?${params}`),//店铺信息  
    queryCategory: (params) => myAjax.get(`product/queryCategory?${params}`),//类别
    queryShopNotice: (params) => myAjax.get(`shopNotice/queryShopNotice?${params}`),//商家公告
    getProduct: (params) => myAjax.post(`activi/getProduct`, params),//店铺下的秒杀专区
    selectByShopMaxPageview: (params) => myAjax.get(`product/selectByShopMaxPageview?${params}`,),//店铺下的商品浏览量
    notLogCoupon: (params) => myAjax.get(`coupcon/notLogCoupon?${params}`,),//店铺下的商品浏览量

    postQueryLiveIng: (params) => myAjax.post(`pushLive/queryLiveIng`, params),//直播列表 
    queryLiveProduct: (params) => myAjax.get(`pushLive/queryLiveProduct?${params}`),//直播商品列表

    getUnreadMsgNum: () => myAjax.get(`im/getUnreadMsgNum`),//消息提示数 
    getMsgShop: (params) => myAjax.get(`im/getMsgShop?${params}`),//消息
    deleteMsgShop: (params) => myAjax.get(`im/deleteMsgShop?${params}`),//消息
    cleanUnreadMsgNum: (params) => myAjax.get(`im/cleanUnreadMsgNum?${params}`),//消息

    getFootprint: () => myAjax.get(`buyerFootprint/getFootprint`),//足迹
    getRemoveFootprint: (params) => myAjax.get(`buyerFootprint/removeFootprint?${params}`),//移除

    getHelp: (params) => myAjax.get(`operationalManual/search?${params}`),//帮助

    getBuyerIntegral: () => myAjax.get(`integralProduct/getBuyerIntegral`),//积分
    getBuyerIntegralLog: (params) => myAjax.get(`integralProduct/getBuyerIntegralLog?${params}`),//客户积分流水
    selectProductList: (params) => myAjax.post(`integralProduct/getBuyerProductList`, Qs.stringify(params)),//积分商品列表
    orderList: (params) => myAjax.post(`integralProduct/orderList`, Qs.stringify(params)),//积分商品列表
    saveOrder: (params) => myAjax.post(`integralProduct/saveOrder`, params),//积分商品列表
    getLogisticsInfo: (params) => myAjax.get(`integralProduct/getLogisticsInfo?${params}`),//客户积分流水
	
	getInteAddress: () => myAjax.get(`integralProduct/address/${store.state.buyerId}`),//收货地址列表
	postInteAddress: (params) => myAjax.post(`integralProduct/address`, params),//新增收货地址
	putInteAddress: (params) => myAjax.put(`integralProduct/address`, params),//修改收货地址
	// delInteAddress: (params) => myAjax.delete(`buyer/delete/${params}`),//删除收货地址 
	
	
	getStateMessage: (params) => myAjax.post(`/express/getExpressType`, params),//积分商品物流
	
	getintegralDetails: (params) => myAjax.post(`integralProduct/orderInfo/${params}`),//积分商品订单信息
	
	

    evaluateInfo: (params) => myAjax.post(`serviceEvaluation/evaluateInfo`, params),//客服评价
    payBeforeValidated: (params) => myAjax.get(`order/payBeforeValidated?${params}`),// 聚合付支付
    selectCreditList: (params) => myAjax.post(`buyerCredit/selectCreditList`, params),//账期列表
    uploadCredit: (params) => myAjax.post(`buyerCredit/uploadCredit`, params),//账期上传
    selectCreditByNoSubmit: () => myAjax.post(`buyerCredit/selectCreditByNoSubmit`),//账期上传
    getBuyerCredit: (params) => myAjax.post(`buyerCredit/getBuyerCredit`, Qs.stringify(params)),//

	getNewCoupon: (params) => myAjax.get(`coupcon/newCoupon?${Qs.stringify(params)}`),//优惠券列表




    //商学院---------------------------------------------------------------------------------------
    selesCaseCategory: () => myAjax.get(`information/selesCaseCategory`),//栏目
    selesInformationHome: (params) => myAjax.get(`information/selesInformationHome?${params}`),//首页推荐
    selesCaseType: (params) => myAjax.get(`information/selesCaseType?${params}`),//分类
    selesInformationCase: (params) => myAjax.get(`information/selesInformationCase?${params}`),//列表
    setLookLog: (params) => myAjax.get(`information/setLookLog?${params}`),//视频记录播放时间
    getLookTime: (params) => myAjax.get(`information/getLookTime?${params}`),//获取视频记录播放时间
    selesInformationList: (params) => myAjax.get(`information/selesInformationList?${params}`),//章节列表
    selesInformationInfo: (params) => myAjax.get(`information/getInformationInfo?${params}`),//课时列表
    getCollectState: (params) => myAjax.get(`information/getCollectState?${params}`),//获取收藏
    addCollect: (params) => myAjax.get(`information/addCollect?${params}`),//添加收藏
    delCollect: (params) => myAjax.get(`information/delCollect?${params}`),//删除收藏
    getCollectList: (params) => myAjax.get(`information/getCollectList?${params}`),//删除收藏
    getConcernList: (params) => myAjax.get(`information/getConcernList?${params}`),//获取关注列表
    getLookLog: (params) => myAjax.get(`information/getLookLog?${params}`),//获取记录列表
    getConcernState: (params) => myAjax.get(`information/getConcernState?${params}`),//获取关注状态
    delConcern: (params) => myAjax.get(`information/delConcern?${params}`),//删除关注状态
    addConcern: (params) => myAjax.get(`information/addConcern?${params}`),//添加关注状态
    addSubscription: (params) => myAjax.get(`information/addSubscription?${params}`),//添加订阅状态
    delSubscription: (params) => myAjax.get(`information/delSubscription?${params}`),//删除订阅状态
    getSubscriptionList: (params) => myAjax.get(`information/getSubscriptionList?${params}`),//获取订阅列表
    selesTeacher: (params) => myAjax.get(`information/selesTeacher?${params}`),//获取订阅列表
    informationPay: (params) => myAjax.post(`information/pay`, params),//获取订阅列表
    payResult: (params) => myAjax.get(`information/payResult/${params}`),//获取订阅列表
    getBuyList: (params) => myAjax.get(`information/getBuyList?${params}`),//获取已购列表
	

    //------------------------------------------------------区域

    selectArea: (params) => myAjax.get(`producaArea/selectArea?${params}`),//品牌专区切换
    selectProductInfo: (params) => myAjax.get(`producaArea/selectProductInfo?${params}`),//积分商品列表
    updateOpenId: (params) => myAjax.get(`order/updateOpenId?${params}`),//加入openID
    getopenId: (params) => myAjax.get(`getopenId?${params}`),//积分商品列表


    //单商铺
    postProduct: (params) => myAjax.post(`product/selectRegionalProduct`, params),//地域商品
    selectRegionalShop: () => myAjax.get(`product/selectRegionalShop`),//店铺列表
	
	
	// 会员--------------------------
	selectBuyerVipLevel: () => myAjax.get(`buyerVip/selectBuyerVipLevel/${store.state.buyerId}`),//查询会员等级
	
	getActiviProList: (activityType,params) => myAjax.get(`activi/getActiviProList/${activityType}?${params}`,),//查询促销 特卖
	
	
	queryShopPay: (params) => myAjax.get(`ShopCase/queryShopPay/${params}`),//查询线下支付信息
	
	offlinePay: (params) => myAjax.post(`order/offlinePay`, params ),//线下支付
	
	submitPayment: (params) => myAjax.post(`order/submitPayment`, params ),//提交线下支付凭证
	
	changePhone: (params) => myAjax.post(`buyer/changePhone`, params ),//修改手机号
	
	
	hotsellinglist: (params) => myAjax.post(`product/hotsellinglist?${params}`),//热销商品
	
	newlyaddedtoday: (params) => myAjax.post(`product/newlyaddedtoday?${params}`),//今日上新
	
	
	alllist: (params) => myAjax.get(`api/title/config/alllist/${params}`),

}
export default myaxios



// WEBPACK FOOTER //
// ./src/components/api/api.js